import { __awaiter, __extends, __generator } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { DeprecatedLinkButton } from '../../primitives/deprecated-buttons/deprecated-link-button/link-button';
import { SimpleAudioPlayer } from '../simple-audio-player';
import { ErrorXIcon } from './error-x';
var fileSizeToString = function (size) {
    if (size < 1024) {
        return size + "B";
    }
    else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(1) + "KB";
    }
    else {
        return (size / (1024 * 1024)).toFixed(1) + "MB";
    }
};
var AudioUploader = /** @class */ (function (_super) {
    __extends(AudioUploader, _super);
    function AudioUploader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileInput = null;
        _this.state = {
            isUploading: false,
            progressPercentage: 0,
            fileSize: 0,
            fileName: '',
            errorMessage: ''
        };
        _this.clearProgress = function () { return _this.setState({ isUploading: false, progressPercentage: 0, fileSize: 0, fileName: '' }); };
        _this.updateProgress = function (progressPercentage) {
            _this.setState({ progressPercentage: progressPercentage });
        };
        _this.insertFile = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var file, size, isSizeOK, translate, fileExtension, supportedFileTypes, isTypeOk, fileUrl, isAudio, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        file = event.target.files[0];
                        size = file.size;
                        isSizeOK = size < this.props.fileUploader.uploadLimitInBytes;
                        translate = this.props.translateFn;
                        this.setState({ isUploading: true, fileSize: size, fileName: file.name });
                        fileExtension = file.type.split('/').reverse()[0];
                        supportedFileTypes = this.props.fileUploader.supportedFileTypes;
                        isTypeOk = !!fileExtension && (supportedFileTypes.includes("." + fileExtension) || supportedFileTypes.includes("" + file.type));
                        if (!isTypeOk) return [3 /*break*/, 7];
                        if (!isSizeOK) return [3 /*break*/, 5];
                        this.setState({ errorMessage: '' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.fileUploader.uploadFileWithProgress(file, this.updateProgress)];
                    case 2:
                        fileUrl = _a.sent();
                        if (fileUrl) {
                            if (!this.state.isUploading) {
                                return [2 /*return*/];
                            }
                            isAudio = file.type.indexOf('audio') !== -1;
                            if (isAudio) {
                                this.props.onAudioFileChange(fileUrl, file.name);
                                this.clearProgress();
                            }
                            else {
                                this.setState({ errorMessage: translate('common.audio-uploader.error-type', { name: file.name }) });
                            }
                        }
                        else {
                            this.setState({ errorMessage: translate('common.audio-uploader.error-general') });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState({ errorMessage: translate('common.audio-uploader.error-general') });
                        throw e_1;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.setState({ errorMessage: translate('common.audio-uploader.error-size', { name: file.name }) });
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.setState({ errorMessage: translate('common.audio-uploader.error-invalid-attachment', { name: file.name }) });
                        _a.label = 8;
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        _this.handleFileDrop = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        e.stopPropagation();
                        if (!(e.type === 'drop')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.insertFile({
                                target: {
                                    files: e.dataTransfer.files
                                }
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.openFileInput = function (e) {
            if (e) {
                e.stopPropagation();
            }
            if (_this.fileInput) {
                _this.fileInput.click();
            }
        };
        _this.cancelUpload = function () { return _this.clearProgress(); };
        _this.retryUpload = function () {
            if (_this.fileInput) {
                _this.fileInput.value = '';
            }
            _this.openFileInput();
            _this.setState({ errorMessage: '' });
            _this.clearProgress();
        };
        _this.renderAudioPlayer = function () { return (React.createElement("div", { className: 'uploader-container' },
            React.createElement(SimpleAudioPlayer, { audioUrl: _this.props.audioUrl || '', title: _this.props.audioTitle || ' ' }),
            React.createElement("div", { className: 'action-button-container' },
                React.createElement("span", { className: 'action-button' },
                    React.createElement(DeprecatedLinkButton, { onClick: _this.openFileInput }, _this.props.translateFn('common.audio-uploader.replace')))))); };
        _this.renderUploadProgress = function () {
            var offset = -1 * _this.state.progressPercentage * 62.832 / 100;
            return (React.createElement("div", { className: 'uploader-container' },
                React.createElement("div", { className: 'progress-icon' },
                    React.createElement("svg", { className: 'progress-icon-svg', viewBox: '0 0 47 47' },
                        React.createElement("circle", { id: 'outer', cx: '23.5', cy: '23.5', r: '22.5' }),
                        React.createElement("circle", { id: 'inner', cx: '23.5', cy: '23.5', r: '10', strokeWidth: '20', strokeDasharray: '62.83', strokeDashoffset: offset }))),
                React.createElement("div", { className: 'text-wrapper' },
                    React.createElement("div", { className: 'file-name-wrapper' },
                        React.createElement("div", { className: 'file-name' }, _this.state.fileName),
                        React.createElement("div", { className: 'file-size' }, "(" + fileSizeToString(_this.state.fileSize) + ")")),
                    React.createElement("div", { className: 'uploading' }, _this.props.translateFn('common.audio-uploader.uploading'))),
                React.createElement("div", { className: 'action-button-container' },
                    React.createElement("span", { className: 'action-button' },
                        React.createElement(DeprecatedLinkButton, { onClick: _this.cancelUpload }, _this.props.translateFn('common.cancel'))))));
        };
        _this.renderErrorMessage = function () { return (React.createElement("div", { className: 'uploader-container' },
            React.createElement("div", { className: 'error-icon' },
                React.createElement(ErrorXIcon, null)),
            React.createElement("div", { className: 'text-wrapper' },
                React.createElement("div", { className: 'file-name-wrapper' },
                    React.createElement("div", { className: 'file-name' }, _this.state.fileName),
                    React.createElement("div", { className: 'file-size' }, "(" + fileSizeToString(_this.state.fileSize) + ")")),
                React.createElement("div", { className: 'error-message' }, _this.state.errorMessage)),
            React.createElement("div", { className: 'action-button-container' },
                React.createElement("span", { className: 'action-button' },
                    React.createElement(DeprecatedLinkButton, { onClick: _this.retryUpload }, _this.props.translateFn('common.audio-uploader.retry')))))); };
        _this.renderEmptyState = function () { return (React.createElement("div", { className: 'uploader-container empty-state', onDragOver: _this.handleFileDrop, onDrop: _this.handleFileDrop, onClick: _this.openFileInput },
            React.createElement(DeprecatedLinkButton, { onClick: _this.openFileInput }, _this.props.translateFn('common.audio-uploader.upload-file')))); };
        return _this;
    }
    AudioUploader.prototype.render = function () {
        var _this = this;
        var key = 'audio-uploader';
        var classNames = namespacedClassnames(key);
        var isUploading = this.state.isUploading;
        var error = !!this.state.errorMessage;
        var url = this.props.audioUrl;
        return (React.createElement("div", { className: classNames },
            React.createElement("input", { type: 'file', ref: function (input) { _this.fileInput = input; }, multiple: false, accept: this.props.fileUploader.supportedFileTypes.join(','), style: { display: 'none' }, onChange: this.insertFile }),
            isUploading && (error ? this.renderErrorMessage() : this.renderUploadProgress()),
            !isUploading && (url ? this.renderAudioPlayer() : this.renderEmptyState())));
    };
    return AudioUploader;
}(React.Component));
export { AudioUploader };
//# sourceMappingURL=audio-uploader.comp.js.map